import { render, staticRenderFns } from "./QuestionTopicDetail.vue?vue&type=template&id=7952b81b&scoped=true&"
import script from "./QuestionTopicDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionTopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTopicDetail.vue?vue&type=style&index=0&id=7952b81b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7952b81b",
  null
  
)

export default component.exports